import { z } from "zod"

export const BackofficeReferralLeadResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  companyName: z.string(),
  website: z.string().nullish(),
  contactName: z.string(),
  role: z.string().nullish(),
  email: z.string(),
  phone: z.string(),
  credits: z.number(),
  createdAt: z.date().transform((value) => value.toISOString()),
  employee: z.object({
    id: z.bigint().transform(String),
    name: z.string(),
    email: z.string(),
  }),
  organization: z.object({
    id: z.bigint().transform(String),
    name: z.string(),
  }),
})

export const BackofficeReferralsResponseDataSchema = z.array(
  BackofficeReferralLeadResponseDataSchema,
)
